import React from 'react';
import TextField from '@mui/material/TextField';
import { validateEmail } from '@/utils/misc.ts';
import CheckIcon from '@mui/icons-material/Check';
import { FormHelperTextProps } from '@mui/material';

interface EmailFieldWithCheckProps {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  variant?: 'outlined' | 'standard';
  multiline?: boolean;
  rows?: number;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  FormHelperTextProps?: Partial<FormHelperTextProps>;
}

const EmailFieldWithCheck: React.FC<EmailFieldWithCheckProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  variant = 'outlined',
  multiline = false,
  rows = 1,
  helperText,
  error,
  disabled,
  FormHelperTextProps,
}) => {
  const renderCheckIconEmail = (value: string) => {
    return validateEmail(value) ? <CheckIcon color="primary" /> : null;
  };

  return (
    <TextField
      id={id}
      name={name}
      label={label}
      variant={variant}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      InputProps={{
        endAdornment: renderCheckIconEmail(value),
      }}
      multiline={multiline}
      rows={rows}
      helperText={helperText}
      error={error}
      disabled={disabled}
      fullWidth
      FormHelperTextProps={FormHelperTextProps}
    />
  );
};

export default EmailFieldWithCheck;
